import {
  ComponentData,
  BlueprintData,
  ActivityBlueprintData,
  ContainerManifestEntry
} from '@fluidx/office-fluid-types';

export function isComponentData(data: any): data is ComponentData {
  return (data as ComponentData).isComponentData;
}

export function isBlueprintData(data: any): data is BlueprintData {
  return (data as BlueprintData).isBlueprintData;
}

export function isActivityBlueprintData(data: any): data is ActivityBlueprintData {
  return (data as ActivityBlueprintData).isActivityBlueprintData;
}

export function isContainerManifestEntry(data: any): data is ContainerManifestEntry {
  // Exception added when eslint rule was added, this should be revisited when modifying this code
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return (data as ContainerManifestEntry).codeDetails !== undefined;
}
